import React from 'react';
import './Header.css';

const Header = () => {
  return (
    <header className="header">
      <div className="header-content">
        <h1>Next Topic Prediction</h1>
        <p>Dive deep into any topic with AI-powered multiple perspectives</p>
      </div>
    </header>
  );
};

export default Header; 